import React, {useState, useEffect} from 'react'
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import {TextField, IconButton, FormControlLabel, Checkbox, Grid, Box, Typography, Container} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import AppContainer from '../components/AppContainer';
import TextContainer from '../components/TextContainer';
import { PRIMARY_COLOR } from '../colorPalette';
// react router
import { useNavigate, Link } from 'react-router-dom';
// validation
import { Formik, ErrorMessage, Field, Form } from 'formik';
import { groupNameSchema, loginSchema } from '../validation/schemas';
// Redux
import { useDispatch, useSelector } from 'react-redux';
import { setLoading, setError, updateUser, setUserLoaded } from '../redux/userSlice';
// firebase
import { getAuth, signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { setPersistence, browserLocalPersistence, browserSessionPersistence } from "firebase/auth";

export default function SignIn() {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const groups = useSelector((state) => state.group.groups);
  const hearts = useSelector((state) => state.heart.hearts);
  const loading = useSelector((state) => state.user.loading);
  const groupHearts = useSelector((state) => state.heart.groupHearts);
  const error = useSelector((state) => state.user.error);

  const [groupFetchComplete, setGroupFetchComplete] = React.useState(false);

  const [rememberMe, setRememberMe] = useState(false);

  const handleFormSubmit = async (values, {setSubmitting}) => {
    console.log("Values", values);
    const userEmail = values.email.trim().toLowerCase();  // trim and lowercase email when submitting
    const userPassword = values.password;
    setSubmitting(true);

    const auth = getAuth(); // Initialize Firebase Auth

    console.log("Clicked login button with email and password: ", userEmail, userPassword);

    try {
      dispatch(setLoading(true));

      // Set persistence based on the "Remember Me" checkbox state
      await setPersistence(auth, rememberMe ? browserLocalPersistence : browserSessionPersistence);
      rememberMe && console.log("Remember Me is checked. Using local persistence.");

      // Log in the user with Firebase
      const userCredential = await signInWithEmailAndPassword(auth, userEmail, userPassword);
      const firebaseUser = userCredential.user;
      console.log("User logged into Firebase successfully:", firebaseUser, userCredential);

      // FetchUserData and navigation to home automatically handled by useEffect in App.js!

    } catch (error) {
      console.error("Error logging in user:", error.message);
      dispatch(setError(error.message));
      dispatch(setLoading(false));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AppContainer>
      <Formik
          initialValues={{ email: '', password: '' }}
          validationSchema={loginSchema}
          onSubmit={handleFormSubmit}
      >
        {({ isSubmitting, errors, touched }) => (
          <Form>
            <Box style={{ display: 'flex', flexDirection: 'column', minHeight: window.innerHeight, alignItems: 'center' }}>
                <Box sx={{marginTop: '50px', width: '100%'}}>
                    <IconButton color='black' onClick={() => {navigate(-1)}}>
                      <ArrowBackIcon/>
                    </IconButton>
                </Box>
                <Avatar sx={{ m: 1, bgcolor: PRIMARY_COLOR }}>
                  <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">Sign in</Typography>
                <TextContainer>
                  <Field 
                    as={TextField}
                    id='email'
                    name='email'
                    sx={{width: '100%', marginTop: '20px'}} 
                    label="Email"
                    variant="filled" 
                    required
                    error={errors.email && touched.email}
                  />
                  <ErrorMessage name="email" component="div" style={{ color: 'red' }} />
                  <Field 
                    as={TextField}
                    id='password'
                    type='password'
                    name='password'
                    sx={{width: '100%', marginTop: '20px'}} 
                    label="Password"
                    variant="filled" 
                    required
                    error={errors.password && touched.password}
                  />
                  <ErrorMessage name="password" component="div" style={{ color: 'red' }} />
                  <FormControlLabel
                    control={
                      <Checkbox
                        value="remember"
                        color="primary"
                        checked={rememberMe}
                        onChange={(e) => setRememberMe(e.target.checked)}
                      />
                    }
                    label="Remember me"
                  />
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                    disabled={loading}
                  >
                    {loading ? "Logging in..." : "Log In"}
                  </Button>
                  {/* Login error message */}
                  {error && <Typography style={{ color: 'red' }} >{error}</Typography>}
                  <Link to={"/reset-password"} variant="body2" style={{marginTop: '20px'}}>
                    Forgot password?
                  </Link>
                  <Box sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      marginTop: 2,
                      paddingTop: 2,
                      borderTop: '1px solid #ddd',
                      position: 'relative',
                      width: '100%',
                    }}>
                    <Box component="span" sx={{ flex: 1, borderBottom: '1px solid #ddd', marginRight: 1,}}/>
                    <Typography sx={{ fontSize: '14px', color: '#555', marginBottom: '10px'}}>Don't have an account?</Typography>
                    <Button fullWidth variant="outlined" onClick={() => {navigate('/sign-up')}}>Create an account</Button>
                  </Box>
                {/* </Box> */}
                </TextContainer>
            </Box>

            {/* </Box> */}
          </Form>
        )}
      </Formik>
    </AppContainer>
  );
}